import React from 'react';
import { ParallaxProvider as ParallaxProviderOrig } from 'react-scroll-parallax';
import { IS_CLIENT } from '../../config/constants';

// Type assertion needed for react-scroll-parallax compatibility with newer React types.
const TypedParallaxProvider = ParallaxProviderOrig as React.FC<React.PropsWithChildren>;

// The original ParallaxProvider does not work properly with SSR, so wrap it.
const ParallaxProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  if (IS_CLIENT) {
    return (
      <TypedParallaxProvider>{ children }</TypedParallaxProvider>
    );
  }

  return children;
};

export default ParallaxProvider;
